// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gp-0";